export const NOTIFICATION_TYPES = {
  error: 'error',
  loading: 'loading',
  success: 'success',
};
